import { alert } from 'equasion-lib';
import { playFailTone } from './feedback';

type AlertIcon = 'success' | 'error' | 'warning' | 'info' | 'question';

/**
 * The error toast a scan refusal shows. Plays the fail tone with it, so the sound and the
 * modal arrive together. Mutation failures that already toast from the Apollo error link call
 * `playFailTone` once in their catch instead, and keep using `alert` for the page's own copy.
 */
export const scanAlert = (
  title: string,
  text: string,
  timerSeconds = 6,
  icon: AlertIcon = 'error'
) => {
  if (icon === 'error' || icon === 'warning') playFailTone();
  alert(title, text, timerSeconds, icon);
};
